export default __webpack_public_path__ + "static/media/Old-White.6b07b0b7.jpg";